import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrPlusIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M8.70068 2.99982C8.70069 2.61322 8.3873 2.29981 8.0007 2.2998C7.6141 2.2998 7.30069 2.61319 7.30068 2.99979L7.3006 7.30957H3.00078C2.61418 7.30957 2.30078 7.62297 2.30078 8.00957C2.30078 8.39617 2.61418 8.70957 3.00078 8.70957H7.30058L7.3005 12.9998C7.30049 13.3864 7.61389 13.6998 8.00049 13.6998C8.38709 13.6998 8.70049 13.3864 8.7005 12.9998L8.70058 8.70957H13.0045C13.3911 8.70957 13.7045 8.39617 13.7045 8.00957C13.7045 7.62297 13.3911 7.30957 13.0045 7.30957H8.7006L8.70068 2.99982Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrPlusIconComponent;
